import Vue from 'vue'

function parseSavedSession () {
  const saved = JSON.parse(localStorage.getItem('DAYZ_SESSION') || '{}')
  if (saved && !saved.expiresAt) {
    localStorage.removeItem('DAYZ_SESSION')
    return { token: '', user: null, expiresAt: 0 }
  }
  if (saved && saved.expiresAt && Date.now() > saved.expiresAt) {
    localStorage.removeItem('DAYZ_SESSION')
    return { token: '', user: null, expiresAt: 0 }
  }
  return {
    token: saved.token || '',
    user: saved.user || null,
    expiresAt: saved.expiresAt || 0
  }
}

export const session = Vue.observable(parseSavedSession())

export function hasValidSession () {
  if (!session.token) return false
  if (!session.expiresAt) {
    clearSession()
    return false
  }
  if (session.expiresAt && Date.now() > session.expiresAt) {
    clearSession()
    return false
  }
  return true
}

export function setSession (token, user, expiresAtMs) {
  session.token = token
  session.user = user
  session.expiresAt = expiresAtMs || 0
  persist()
}

export function clearSession () {
  session.token = ''
  session.user = null
  session.expiresAt = 0
  persist()
}

export function unPersist () {
  localStorage.removeItem('DAYZ_SESSION')
}

function persist () {
  localStorage.setItem('DAYZ_SESSION', JSON.stringify({
    token: session.token,
    user: session.user,
    expiresAt: session.expiresAt
  }))
}
